import React, { useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

export const DragAndDrop = (props) => {
  const { items } = props;

  const [ingredients, setIngredients] = useState([]);

  useEffect(() => {
    setIngredients(items);
  }, [items]);

  const reorder = (list, startIndex, endIndex) => {
    const result = [...list];
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  return (
    <>
      <DragDropContext
        onDragEnd={(result) => {
          const { source, destination } = result;
          if (!destination) {
            return;
          }
          if (
            source.index === destination.index &&
            source.droppableId === destination.droppableId
          ) {
            return;
          }

          setIngredients((prevIngredients) =>
            reorder(prevIngredients, source.index, destination.index)
          );
        }}
      >
        <Droppable droppableId="ingredients" direction="horizontal">
          {(droppableProvided) => (
            <div
              {...droppableProvided.droppableProps}
              ref={droppableProvided.innerRef}
              className="flex-container"
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              {ingredients.length > 0 &&
                ingredients.map((ingredient, index) => (
                  <Draggable
                    key={ingredient.id}
                    draggableId={ingredient.id}
                    index={index}
                  >
                    {(draggableProvided) => (
                      <div className="p-5 m-1">
                        <div
                          className="bg-white p-5 m-1"
                          {...draggableProvided.draggableProps}
                          ref={draggableProvided.innerRef}
                          {...draggableProvided.dragHandleProps}
                        >
                          {ingredient.name}
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}
              {ingredients.length === 0 && (
                <p className="m-5 ">Añade ingredientes para ordenarlos...</p>
              )}
              {droppableProvided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      <input
        hidden={true}
        value={ingredients.map((ing) => {
          return ing.id;
        })}
        id="name_order"
        name="name_order"
      ></input>
    </>
  );
};
